module.exports = __webpack_public_path__ + "img/svip.d2c45339.png";